<!-- 首页版块语录组件 -->
<template>
  <div class="quotation-wrap">
    <div class="name-box">
      <span style="text-align: center;">王选语录</span>
    </div>
    <div class="content-box">
      <div class="quo-l"></div>
      <span>{{ content }}</span>
      <div class="quo-r"></div>
    </div>
  </div>
</template>

<script>
  export default {
    components: { },
    props: {
      content: null,
    },
    data() {
        return {

        };
      },
    methods: {

    },
    created() {},
    mounted() {}
  };
</script>

<style scoped>
  .quotation-wrap{
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 0px;
    /*gap: 20px;*/
    width: 80%;
  }

  .name-box{
    flex: 0 0 64px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    flex-direction: column;
    padding: 10px;    
    background: #815119;
    color: #FFFFFF;
    font-size: 20px;
    font-weight: 250;
    line-height: 20px;
    letter-spacing: 0em;
    box-sizing: border-box;
    align-items: center;
    justify-content: center;
    
  }

  .content-box{
    /*
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 0px;
    gap: 20px;
    */
    font-size: 16px;
    font-weight: normal;
    line-height: 32px;
    letter-spacing: 0em;
    color: #000000;
    margin-left: 20px;
  }
  .quo-l{
    background:url('~@/assets/icons/svg/quo-l.svg') no-repeat;
    background-size: cover;
    width: 20px;
    height: 28px;
    float: left;
  }
  .quo-r{
    background:url('~@/assets/icons/svg/quo-l.svg') no-repeat;
    background-position: center bottom;
    background-size:contain;
    width: 20px;
    height: 28px;    
    display: inline-block;
    transform: rotate(180deg);
  }
  @media screen and (max-width: 650px) {
    .quotation-wrap{
      width: 80%;
      /*gap: 8px;*/
      flex-direction: column;
      align-items: center;
      
    }
    .name-box{
      font-size: 14px;      
      line-height: 18px;
      padding: 4px;
      flex: unset;
      
    }
    .content-box{
      font-size: 14px;
      line-height: 28px;      
      color: #3B3F47;
      margin-left: 8px;
    }
    .quo-l{    
      width: 18px;
      height: 18px;    
    }
  .quo-r{    
      width: 18px;
      height: 18px; 
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/blocks/quotation/index.vue